import { useRuntimeConfig } from '#imports'

import type { Market } from '@backmarket/http-api'
import type { RouteRecordRaw } from 'vue-router'

import { MODELS_COMPARISON } from './routes-names'

// TODO: move ModelsComparisonHome and ModelsComparisonSearch pages inside a folder of their own

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const { FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_MODELS_COMPARISON = '' } =
    useRuntimeConfig().public

  const isOpenInFrontApps =
    FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_MODELS_COMPARISON.includes(
      market.countryCode,
    )

  return [
    {
      path: '/:locale/compare',
      meta: {
        disableClientSideNavigation: () => !isOpenInFrontApps,
      },
      children: [
        {
          name: MODELS_COMPARISON.HOME,
          path: 'home',
          component: () => import('./pages/ModelsComparisonHome.vue'),
        },
        {
          name: MODELS_COMPARISON.CATEGORY,
          path: ':category',
          component: () => import('./pages/ModelsComparisonSearch.vue'),
        },
        {
          name: MODELS_COMPARISON.COMPARISON_RESULTS,
          path: ':productA/:productB',
          component: () =>
            import(
              './pages/ModelsComparisonResults/ModelsComparisonResults.vue'
            ),
        },
      ],
    },
  ]
}
